




































import { defineComponent, toRefs, ref, PropType } from 'vue-demi';
import { i18n } from '../../../i18n';
import { useCoupon } from './hooks/use-coupon';
import Amount from '../common/amount.vue';
import { language } from '@tencent/ppd-base-libs';
import { ShareCouponInfo } from '@tencent/wphk-act-base-cgi';

type ExShareCouponInfo = ShareCouponInfo & {
  /** 分享券卡片背景图 */
  couponBgUrl: string;
  /** 分享券卡片背景色 */
  couponBgColor: string;
  /** 分享券详情弹层背景图 */
  couponDtlBgUrl: string;
  /** 分享券详情弹层头部挂图 */
  topTipUrl: string;
  /** 分享券详情弹层虚线 */
  couponDtlSplitLine: string;
};

export default defineComponent({
  name: 'ShareCouponSmall',
  props: {
    couponInfo: {
      type: Object as PropType<ExShareCouponInfo>,
      required: true,
    },
  },
  components: {
    Amount,
  },
  setup(props, { emit }) {
    /** 是否是英文 */
    const isEn = language.isEn();
    /** 金额组件 */
    const amount = ref<InstanceType<typeof Amount>>();

    const { isShow, btnTxt, isBtnGrey, onClick } = toRefs(useCoupon(props.couponInfo, emit));
    return {
      isEn,
      i18n,
      amount,
      isShow,
      btnTxt,
      isBtnGrey,
      onClick,
    };
  },
});
